//控制是否打印
const allowLog = true
export default {
    install(Vue) {
        /**
         * @description: 对于this.log的封装，
         * @param {type} 
         * @return: 
         */
        if (allowLog) {
          try {
            Vue.prototype.log = console.log;
            //尝试运行，是否报错
            Vue.prototype.log("success console proxy")
          } catch (error) {
            //ie11和android 4.4  this._generic(MessageLevel.Log, [].slice.call(arguments)  _generic报错
            console.warn("fail console proxy")
            Vue.prototype.log = function () {}
          }
        } else {
            Vue.prototype.log = function () {}
        }
   }
}



// WEBPACK FOOTER //
// ./src/assets/unit/log.js